module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Medium-924959a3d51830c3e27341a32567ad7b.ttf";